import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { IFindingImageZoomDialogData } from '../finding-card.interface';

@Component({
  imports: [MatDialogModule],
  selector: 'app-finding-image-zoom-dialog',
  template: `
    <img
      class="block max-h-[85vh] max-w-full cursor-zoom-out object-contain"
      mat-dialog-close
      [src]="data.imageUrl"
      [alt]="data.alt"
    />
  `,
})
export class FindingImageZoomDialogComponent {
  public readonly data = inject<IFindingImageZoomDialogData>(MAT_DIALOG_DATA);
}
